import React from "react";
import { useTheme } from "@mui/material/styles";

const EditPhotosIcon = ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.465"
      height="37.512"
      viewBox="0 0 29.465 37.512"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_6628"
            data-name="Rectangle 6628"
            width="29.465"
            height="37.512"
            transform="translate(0 0)"
            fill={color}
          />
        </clipPath>
      </defs>
      <g id="Group_7174" data-name="Group 7174" transform="translate(0 0)">
        <g id="Group_7173" data-name="Group 7173" clipPath="url(#clip-path)">
          <path
            id="Path_8208"
            data-name="Path 8208"
            d="M13.754,12.439v3.272h3.273L26.678,6.06,23.406,2.787ZM29.21,3.528a.869.869,0,0,0,0-1.229h0L27.168.255a.87.87,0,0,0-1.229,0h0l-1.6,1.6,3.273,3.273Z"
            fill={color}
          />
          <path
            id="Path_8209"
            data-name="Path 8209"
            d="M21,15V29H3V3H19.511l1.575-1.575h0L22.454.057A2,2,0,0,0,22,0H2A2,2,0,0,0,0,2V30a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V12Z"
            fill={color}
          />
          <path
            id="Path_8210"
            data-name="Path 8210"
            d="M26.465,9.531v24.48a.5.5,0,0,1-.5.5h-20v3h20a3.5,3.5,0,0,0,3.5-3.5V6.531Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default EditPhotosIcon;
